<template>
  <div class="categoryName">
    追溯召回
  </div>
</template>
<script>
export default{
  props:['categoryName']
}
</script>
<style lang="scss">

</style>




// WEBPACK FOOTER //
// src/components/categoryName/recall.vue